/**
 * @generated SignedSource<<0bf4fe1d90f90f439a06246ad77cca86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "furniture" | "fashion" | "jewelry" | "art" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbRespL1Landing_itemSearch$data = {
  readonly pageType: string | null;
  readonly topCategoryL1: VerticalType | null;
  readonly meta: {
    readonly header: string | null;
    readonly subHeader: string | null;
  } | null;
  readonly l1Module: {
    readonly firstTile: {
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedL1ModuleTile_l1ModuleItemTile">;
    } | null;
    readonly secondTile: {
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedL1ModuleTile_l1ModuleItemTile">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedL1ModuleBanner_l1Module">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedFeaturedDeal_itemSearch" | "SbSharedFeaturedCollection_itemSearch">;
  readonly " $fragmentType": "SbRespL1Landing_itemSearch";
};
export type SbRespL1Landing_itemSearch$key = {
  readonly " $data"?: SbRespL1Landing_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespL1Landing_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "SbSharedL1ModuleTile_l1ModuleItemTile"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "previewId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespL1Landing_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedFeaturedDeal_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedFeaturedCollection_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "previewId",
          "variableName": "previewId"
        }
      ],
      "concreteType": "L1Module",
      "kind": "LinkedField",
      "name": "l1Module",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedL1ModuleBanner_l1Module"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "L1ModuleItemTile",
          "kind": "LinkedField",
          "name": "firstTile",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "L1ModuleItemTile",
          "kind": "LinkedField",
          "name": "secondTile",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "2154b4601fbf6bfe15dbf7a60bcc5fa5";

export default node;
